import 'dragdroptouch';
import 'hammerjs';

declare var Hammer: any;
import { HAMMER_GESTURE_CONFIG, HammerGestureConfig
       } from '@angular/platform-browser';

import { APP_BASE_HREF } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';

import { CollageDesignerModule
       } from 'collage-designer/collage-designer.module';
import { ConfigService } from 'core/config/config.service';
import { CoreModule } from 'core/core.module';
import { ErrorModule } from 'core/error/error.module';
import { MatModule } from 'core/material/mat.module';
import { PipesModule } from 'core/pipes/pipes.module';
import { PriceModule } from 'core/price/price.module';
import { AdditionalProductsSelectionComponent
       } from './additional-products-selection/additional-products-selection.component'; // tslint:disable-line
import { ControlsModule } from './controls/controls.module';
import { DialogsModule } from './dialogs/dialogs.module';
import { FeatureSelectionComponent
       } from './feature-selection/feature-selection.component';
import { GalleryService } from './gallery/gallery.service';
import { OfflineNoticeComponent } from './offline-notice.component';
import { ProductDesignerComponent } from './product-designer.component';
import { ProductDesignerService } from './product-designer.service';
import { ProgressModule } from './progress/progress.module';
import { ProgressService } from './progress/progress.service';
import { ToolboxesModule } from './toolboxes/toolboxes.module';

import { EventTrackingService } from 'core/tracking/event-tracking.service';

import { TranslationModule } from 'core/translation/translation.module';

export class PAPHammerConfig extends HammerGestureConfig
{
  public buildHammer(element: HTMLElement): any
  {
    let mc = new Hammer(element, {
      touchAction: 'pan-y',
    });
    return mc;
  }
}

@NgModule({
  imports: [
      BrowserModule,
      CoreModule.forRoot(),
      CollageDesignerModule,
      ControlsModule,
      ErrorModule,
      FormsModule,
      HttpClientModule,
      MatModule,
      PipesModule,
      PriceModule,
      ProgressModule,
      RouterModule.forRoot([]),
      ToolboxesModule,
      DialogsModule,
      TranslationModule,
  ],
  declarations: [
      AdditionalProductsSelectionComponent,
      FeatureSelectionComponent,
      OfflineNoticeComponent,
      ProductDesignerComponent,
  ],
  providers: [
      EventTrackingService,
      ConfigService,
      GalleryService,
      ProductDesignerService,
      ProgressService,
      { provide: HAMMER_GESTURE_CONFIG, useClass: PAPHammerConfig },
      { provide: APP_BASE_HREF, useValue: '/' },
  ],
  bootstrap: [ ProductDesignerComponent ]
})
export class ProductDesignerModule { }



// WEBPACK FOOTER //
// ./src/app/product-designer.module.ts